import { render, staticRenderFns } from "./work_item_development_relationship_list.vue.js?vue&type=template&id=81cbbc04!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_item_development_relationship_list.vue?vue&type=template&id=81cbbc04"
import script from "./work_item_development_relationship_list.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_item_development_relationship_list.vue?vue&type=script&lang=js"
export * from "./work_item_development_relationship_list.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_item_development_relationship_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports